export default "__VITE_ASSET__oiUL0jyg__"